import EventBus from "../../utils/event_bus";
export default {
  namespaced: true,
  state: {
    selectedAccount: {
      account_id: null,
    },
    accounts: [],
    authenticated: false,
    count_password: false,
    count_code: false,
    user_plan: "",
  },
  getters: {
    getSelectedAccount(state) {
      return state.selectedAccount;
    },
    getAccounts(state) {
      return state.accounts;
    },
    getAuthenticated(state) {
      return state.authenticated;
    },
    getCountPassword(state) {
      return state.count_password;
    },
    getCountCode(state) {
      return state.count_code;
    },
    getUserPlan(state) {
      return state.user_plan;
    },
    getAccountTypes(state) {
      return state;
    },
  },
  actions: {
    incrementNumRunning({ commit }, payload) {
      commit("INCREMENT_NUM_RUNNING", payload);
    },

    decrementNumRunning({ commit }, payload) {
      commit("DECREMENT_NUM_RUNNING", payload);
    },

    updateAccount({ commit }, payload) {
      commit("UPDATE_ACCOUNT", payload.account);
    },

    getAuth({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("GET_AUTH", payload);
        resolve();
      });
    },

    fetchAccounts({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("FETCH_ACCOUNTS", payload);
        resolve();
      });
    },

    updateCountPassword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("UPDATE_COUNT_PASSWORD", payload);
        resolve();
      });
    },

    updateCountCode({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("UPDATE_COUNT_CODE", payload);
        resolve();
      });
    },
  },

  mutations: {
    INCREMENT_NUM_RUNNING(state, payload) {
      state.accounts.forEach((item) => {
        if (item.account_id == payload.account_id) {
          item.num_running++;
        }
      });
    },
    DECREMENT_NUM_RUNNING(state, payload) {
      state.accounts.forEach((item) => {
        if (item.account_id == payload.account_id) {
          item.num_running--;
        }
      });
    },
    GET_AUTH(state, payload) {
      state.authenticated = payload;
    },

    GET_USER(state, payload) {
      const { user_name, user_picture } = payload;
      state.user.user_name = user_name;
      state.user.user_picture = user_picture;
    },

    UPDATE_COUNT_PASSWORD(state, payload) {
      state.count_password = payload;
    },

    UPDATE_COUNT_CODE(state, payload) {
      state.count_code = payload;
    },

    UPDATE_ACCOUNT(state, payload) {
      state.selectedAccount = payload;
      sessionStorage.aid = payload.account_id;
    },

    FETCH_ACCOUNTS(state, payload) {
      // aid = account_id
      // console.log("FETCH_ACCOUNTS", payload);

      const selectFirstAccount = () => {
        sessionStorage.aid = payload[0].account_id;
        state.selectedAccount = payload[0];
      };

      if (payload.some((x) => x.account_id == Number(sessionStorage.aid))) {
        const selected_account = payload.find((account) => account.account_id == Number(sessionStorage.aid));
        state.selectedAccount = selected_account;
      } else {
        selectFirstAccount();
      }

      state.accounts = payload;
      EventBus.$emit("CHANGE_ACCOUNT");
    },
  },
};
